export enum FontFamily {
  body = 'ManifoldCF, sans-serif',
  bold = 'ManifoldCF-Bold, sans-serif',
  heavy = 'ManifoldCF-Heavy, sans-serif',
  heading = 'IntegralCF, sans-serif',
  timberwolf = 'timberwolf, sans-serif',
}

export enum PrimaryColors {
  radical = '#FA104A',
  black = '#000000',
  nearBlack = '#0D0D0D',
  charcoal = '#171717',
  obsidian = '#212121',
  carbon = '#2C2C2C',
  tundora = '#404040',
  concrete = '#626262',
  gravity = '#CACACA',
  diamond = '#F0F0F0',
  white = '#FFF',
  grey = '#A4A4A4',
  available = '#339B44',
  ghost = "#F7F7F8",
  arsenic = "#424242",
}

export enum Breakpoints {
  xs = 0,
  s = 480,
  sm = 600,
  md = 900,
  mdLarge = 1024,
  lg = 1200,
  xl = 1536,
}

export const ALTERNATIVE_LAYOUT_PAGES = ['memberships'];

export const PAGE_WIDTH = 1350;

export const HEADER_HEIGHT_DESKTOP = 132;
export const HEADER_HEIGHT_MOBILE = 92;

export const STEPPER_HEIGHT = 70;
